import React from 'react'

import { TidewaysContext } from '../app/context'
import TransactionTableRowItem from '../monitor/transaction-table-row-item'
import { Box, BoxBody } from '../ui/box'
import { Col } from '../ui/grid'

interface Props {
    data: any
    loading: boolean
    route: string
    collapsable: boolean
    parameters: { [key: string]: string }
    tidewaysContext?: TidewaysContext
}
interface State {
    expanded: boolean
}
class TransactionReport extends React.Component<Props, State> {
    public static defaultProps = {
        loading: false,
        collapsable: false,
        parameters: {},
        route: null,
    }

    public state: State = {
        expanded: false,
    }

    public render() {
        const transactions =
            this.props.collapsable && !this.state.expanded
                ? this.props.data.transactionReport.filter(transaction => transaction.impact >= 1.0)
                : this.props.data.transactionReport

        const hasLowImpactTransactions = this.state.expanded || transactions.length !== this.props.data.transactionReport.length

        return (
            <Col width={12}>
                <Box>
                    <BoxBody {...this.props} className="no-padding">
                        <table className="table table-striped table-fixed">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th style={{ width: 70 }} className="align-right">
                                        Requests
                                    </th>
                                    <th style={{ width: 160 }} className="align-right">
                                        Average Response
                                    </th>
                                    <th style={{ width: 160 }} className="align-right">
                                        {' '}
                                        Slowest Response{' '}
                                    </th>

                                    <React.Fragment>
                                        <th style={{ width: 110 }} className="align-right">
                                            {' '}
                                            Memory{' '}
                                        </th>
                                        <th style={{ width: 110 }} className="align-right">
                                            {' '}
                                            Failures{' '}
                                        </th>
                                    </React.Fragment>
                                    <th style={{ width: 110 }} className="align-right">
                                        Impact <span className="fa fa-sort-desc" />
                                    </th>
                                    <th style={{ width: '20%' }} />
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map(transaction => (
                                    <TransactionTableRowItem
                                        key={transaction.id}
                                        operation={transaction}
                                        route={this.props.route}
                                        full
                                        sparkline={Object.keys(transaction.groups).map(week => ({
                                            start: new Date(transaction.groups[week].range.startDate),
                                            end: new Date(transaction.groups[week].range.endDate),
                                            value: transaction.groups[week].averageResponse,
                                        }))}
                                        parameters={this.props.parameters}
                                        isTideways6={this.props.tidewaysContext?.organization.isTideways6 || false}
                                        showBenchmark={true}
                                    />
                                ))}
                                {this.props.collapsable && hasLowImpactTransactions ? (
                                    <tr>
                                        <td colSpan={8} className="text-center">
                                            <button
                                                className="btn btn-unstyled"
                                                onClick={() => this.setState({ expanded: !this.state.expanded })}
                                            >
                                                {this.state.expanded ? 'hide low impact transactions ...' : 'show all ...'}
                                            </button>
                                        </td>
                                    </tr>
                                ) : null}
                            </tbody>
                        </table>
                    </BoxBody>
                </Box>
            </Col>
        )
    }
}

export default TransactionReport
